import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

//Import Images
import error from "../../assets/images/error-img.png";
import withRouter from "Components/Common/withRouter";

const NoAccessSystem = () => {
  //meta title
  document.title = "Verification Email";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col md="10" lg="8" xl="6">
              <div className="text-center">
                <img
                  src={error}
                  alt="Cuenta en proceso de verificación"
                  className="img-fluid mb-4"
                  style={{ maxWidth: "250px" }}
                />
                <h2 className="text-primary mb-3">
                  Tu cuenta está siendo verificada
                </h2>
                <p className="text-muted">
                  Agradecemos tu registro. Actualmente, nuestro equipo está
                  validando tu información para asegurar el cumplimiento de
                  nuestras políticas.
                </p>
                <p className="text-muted">
                  No podrás iniciar sesión hasta que el proceso haya finalizado.
                  Te notificaremos por correo electrónico tan pronto como tu
                  cuenta esté activa.
                </p>
                <p className="text-muted fst-italic">
                  Este proceso puede tomar un tiempo. Gracias por tu paciencia.
                </p>
                <div className="mt-4">
                  <Link to="/" className="btn btn-outline-primary">
                    Volver al inicio
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(NoAccessSystem);
